<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('cartoon_animation_applications')"
                        :isColumns="true"
                        :actions="actions"
                        @filter-div-status="datatable.filterStatus=$event"
                        :otherButton="{ show: excelImportPermCheck, title: $t('import'), emit:'excelImport'}"
                        @excelImport="excelImport">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column,key) in datatable.columns" :key="key">
                            <b-form-checkbox
                                :id="'checkbox-'+key"
                                :name="'checkbox-'+key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field!='buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('cartoon_animation_applications')"
                              :isColumns="true"
                              :actions="actions"
                              @filter-div-status="datatable.filterStatus=$event"
                              :otherButton="{ show: excelImportPermCheck, title: $t('import'), emit:'excelImport'}"
                              @excelImport="excelImport">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column,key) in datatable.columns" :key="key">
                            <b-form-checkbox
                                :id="'checkbox-'+key"
                                :name="'checkbox-'+key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field!='buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </HeaderMobile>
            </template>
            <datatable-filter
                v-show="datatable.filterStatus"
                :otherButton="{ show: true, title: $t('message_bulk_btn'), emit:'bulkMessage'}"
                :otherButtons="[{ show: true, title: $t('bulk_file_download_btn'), emit:'downloadDocuments'}]"
                :export-excel="true"
                @exportExcel="excelExport"
                @bulkMessage="bulkMessage"
                @downloadDocuments="downloadDocuments"
                @filter="filter"
                @filterClear="filterClear">
                <b-row>
                    <b-col cols="12" md="8">
                        <b-row>
                            <b-col md="6">
                                <b-form-group :label="$t('period')">
                                    <semesters-selectbox v-model="datatable.queryParams.filter.semester_id"
                                                     :multiple="false"/>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group :label="$t('application_group')">
                                    <multi-selectbox v-model="datatable.queryParams.filter.application_group"
                                                     :options="groupOptions"
                                                     :multiple="false"/>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group :label="$t('name')">
                                    <b-form-input type="text" v-model="datatable.queryParams.filter.name"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group :label="$t('surname')">
                                    <b-form-input type="text" v-model="datatable.queryParams.filter.surname"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group :label="$t('exam_date_enter')">
                                    <true-false-selectbox v-model="datatable.queryParams.filter.is_publish_exam_date"
                                                          :multiple="false"/>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group :label="$t('status')">
                                    <multi-selectbox v-model="datatable.queryParams.filter.status"
                                                     :options="statusOptions"
                                                     :multiple="false"/>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group :label="$t('have_a_message')">
                                    <multi-selectbox v-model="datatable.queryParams.filter.have_message"
                                                     :options="haveMessageOptions"
                                                     :multiple="false"/>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group :label="$t('payment_status')">
                                    <multi-selectbox v-model="datatable.queryParams.filter.payment_status"
                                                     :options="paymentStatusOptions"
                                                     :multiple="false"/>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" md="4">
                        <b-form-group :label="$t('national_id')">
                            <lined-textarea
                                v-model="nationalId"
                                :nowrap="false"
                                :onlyNumberAndEnter="true"
                                :disabled="false"
                                :styles="{ height: '18.2em', resize: 'both' }"
                            >
                            </lined-textarea>
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>
            <datatable :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
            >
            </datatable>
            <CommonModal ref="updateModal" size="xl"  :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    <div>{{ updateTitle }}</div>
                </template>
                <template v-slot:CommonModalContent>
                    <update-form
                        :update-data="updateData"
                        :update-mode="updateMode"
                        @updated="afterUpdate"
                        @updatedMsg="afterUpdateMsg"
                        :goTab="goTabIndex"
                        v-if="formProcess==='updateModal'"></update-form>
                </template>
            </CommonModal>
            <CommonModal ref="bulkMessageModal" size="xl">
                <template v-slot:CommonModalTitle>
                    <div>{{ $t('message_bulk_title') }}</div>
                </template>
                <template v-slot:CommonModalContent>
                    <div>
                        <ValidationObserver ref="bulkMessageFormValidate">
                            <b-alert show variant="secondary">
                                <b-row>
                                    <b-col cols="12" class="mb-2">
                                        <b-badge>{{ $t('message_bulk_to') }}</b-badge>
                                    </b-col>
                                    <b-col cols="9" md="10">
                                        <ValidationProvider name="message" rules="required" v-slot="{errors}">
                                            <b-form-group>
                                                <b-form-textarea v-model="bulkMsgForm.message"
                                                                 :class="errors[0] ? 'is-invalid':''"
                                                                 rows="3"
                                                                 :placeholder="$t('message')"
                                                />
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="3" md="2">
                                        <b-button block variant="primary" @click="bulkMessageSend">
                                            {{$t('send')}}
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-alert>
                        </ValidationObserver>
                    </div>
                </template>
            </CommonModal>
            <CommonModal id="importFormModal" size="lg" :onHideOnlyX="true">
                <template v-slot:CommonModalTitle>
                    {{ importModalTitle }}
                </template>
                <template v-slot:CommonModalContent>
                    <b-row>
                        <b-col cols="12" md="10">
                            <ValidationObserver ref="importFormValidate">
                                <ValidationProvider name="file" rules="required" v-slot="{errors}">
                                    <b-input-group class="mb-0">
                                        <b-form-file v-model="importFile"
                                                     :placeholder="$t('upload_file')"
                                                     :state="errors[0] ? false : null"
                                                     ref="fileInput2"
                                        />
                                        <b-input-group-append>
                                            <b-button variant="outline-secondary" @click="$refs.fileInput2.$el.childNodes[0].click()">{{ $t('browse') }}</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                                </ValidationProvider>
                            </ValidationObserver>
                        </b-col>
                        <b-col cols="12" md="2" class="d-flex justify-content-end">
                            <b-button variant="primary" @click="uploadFile">{{ $t('upload') }}</b-button>
                        </b-col>
                    </b-row>
                </template>
            </CommonModal>
            <CommonModal ref="excelImportModal" size="lg" :onHideOnlyX="true">
                <template v-slot:CommonModalTitle>
                    {{ $t('import') }}
                </template>
                <template v-slot:CommonModalContent>
                    <b-row>
                        <b-col cols="12" md="10">
                            <ValidationObserver ref="excelImportFormValidate">
                                <ValidationProvider name="file" rules="required" v-slot="{errors}">
                                    <b-input-group class="mb-0">
                                        <b-form-file v-model="importBulk"
                                                     :placeholder="$t('upload_file')"
                                                     :state="errors[0] ? false : null"
                                                     ref="fileInputBulk"
                                        />
                                        <b-input-group-append>
                                            <b-button variant="outline-secondary" @click="$refs.fileInputBulk.$el.childNodes[0].click()">{{ $t('browse') }}</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                                </ValidationProvider>
                            </ValidationObserver>
                        </b-col>
                        <b-col cols="12" md="2" class="d-flex justify-content-end">
                            <b-button variant="primary" @click="importBulkExcel">{{ $t('upload') }}</b-button>
                        </b-col>
                        <b-col cols="12" md="12" class="mt-2">
                            <download-excel-template :code="'cartoon_animation_application_bulk_import'" />
                        </b-col>
                    </b-row>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
    // Template
    import AppLayout from '@/layouts/AppLayout'
    import Header from '@/layouts/AppLayout/Header'
    import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'

    // Components
    import DatatableFilter from '@/components/datatable/DatatableFilter'
    import Datatable from '@/components/datatable/Datatable'
    import MultiSelectbox from '@/components/interactive-fields/MultiSelectbox'
    import CommonModal from '@/components/elements/CommonModal'
    import TrueFalseSelectbox from '@/components/interactive-fields/TrueFalseSelectbox'
    import LinedTextarea from "@/components/elements/LinedTextarea"
    import SemestersSelectbox from "@/components/interactive-fields/SemestersSelectbox"
    import DownloadExcelTemplate from "@/components/interactive-fields/DownloadExcelTemplate"

    // Pages
    import UpdateForm from './UpdateForm'

    // Services
    import CartoonAnimationService from "@/services/CartoonAnimationService"

    // Others
    import qs from 'qs'
    import { ValidationObserver, ValidationProvider } from 'vee-validate'
    import ConstantService from "@/services/ConstantService";

    export default {
        components: {
            AppLayout,
            Header,
            HeaderMobile,
            ValidationProvider,
            ValidationObserver,

            MultiSelectbox,
            CommonModal,
            TrueFalseSelectbox,
            LinedTextarea,
            SemestersSelectbox,
            DownloadExcelTemplate,

            UpdateForm,
            DatatableFilter,
            Datatable,
        },
        metaInfo() {
            return {
                title: this.$t('cartoon_animation_applications')
            }
        },
        data() {
            return {
                formProcess:null,
                nationalId: '',
                datatable: {
                    actions: [],
                    isLoading: false,
                    columns: [
                        {
                            label: '',
                            field: 'buttons',
                            html: true,
                            sortable: false,
                            tdClass: 'p-0 text-center w-40 align-middle',
                            buttons: [
                                {
                                    text: this.$t('view'),
                                    class: 'ri-search-eye-line align-middle top-minus-1 mr-3 text-muted',
                                    callback: (row) => {
                                        this.openUpdateModal(row, false,0)
                                    },
                                    permission:"cartoonanimationapplication_index"
                                },
                                {
                                    text: this.$t('edit'),
                                    class: 'ri-edit-box-line align-middle top-minus-1 mr-3 text-muted',
                                    callback: (row) => {
                                        this.openUpdateModal(row, true, 0)
                                    },
                                    permission:"cartoonanimationapplication_update"
                                },
                                {
                                    text: this.$t('exam_info_enter'),
                                    class: 'ri-calendar-schedule-line align-middle top-minus-1 mr-3 text-muted',
                                    callback: (row) => {
                                        this.openUpdateModal(row, true, 4)
                                    },
                                    permission:"cartoonanimationapplication_update"
                                },
                                {
                                    text: this.$t('delete'),
                                    class: 'ri-delete-bin-7-line align-middle top-minus-1 mr-3 text-muted',
                                    callback: (row) => {
                                        this.deleteApplication(row)
                                    },
                                    permission:"cartoonanimationapplication_deletecartoonanimationapplication"
                                }
                            ]
                        },
                        {
                            label: this.$t('id'),
                            field: 'id',
                            hidden: false
                        },
                        {
                            label: this.$t('name'),
                            field: 'name',
                            hidden: false
                        },
                        {
                            label: this.$t('surname'),
                            field: 'surname',
                            hidden: false,
                        },
                        {
                            label: this.$t('program'),
                            field: this.getLocaleField('program_name'),
                            hidden: false
                        },
                        {
                            label: this.$t('academic_year'),
                            field: 'academic_year',
                            hidden: false,
                        },
                        {
                            label: this.$t('semester'),
                            field: this.getLocaleField('semester_name'),
                            hidden: false,
                        },
                        {
                            label: this.$t('application_group'),
                            field: 'application_group',
                            hidden: false,
                        },
                        {
                          label: this.$t('payment_status'),
                          field: 'payment_status',
                          hidden: false,
                          formatFn: (row) => {
                            let res = row
                            let clss = ''
                            if(row == 'E'){
                                res = this.$t('yes')
                                clss = 'badge-success'
                            } else {
                              res = this.$t('no')
                                clss = 'badge-danger'
                            }
                            return '<span class="badge '+clss+'">'+res+'</span>'
                          }
                        },
                        {
                            label: this.$t('status'),
                            field: 'status',
                            hidden: false,
                            formatFn: (row) => {
                                let res = row
                                let clss = 'badge-warning'
                                if(row == 'waiting_program'){
                                    res = this.$t('waiting_program')
                                } else if(row == 'waiting'){
                                    res = this.$t('waiting')
                                } else if(row == 'waiting_payment'){
                                  res = this.$t('status_waiting_payment')
                                }
                                return '<span class="badge '+clss+'">'+res+'</span>'
                            }
                        },
                        {
                            label: this.$t('result').toUpper(),
                            field: 'result',
                            hidden: false,
                            formatFn: (row) => {
                                let res = row
                                let clss = 'badge-warning'
                                if(row == 'waiting'){
                                    res = this.$t('waiting')
                                }
                                return '<span class="badge '+clss+'">'+res+'</span>'
                            }
                        }
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {},
                        sort: 'id',
                        page: 1,
                        limit: 20
                    }
                },
                updateData: {},
                updateTitle: null,
                updateMode: false,
                goTabIndex: 0,

                statusOptions: [
                    {
                        value: 'waiting_program',
                        text: this.$t('waiting_program')
                    },
                    {
                        value: 'waiting',
                        text: this.$t('waiting')
                    },
                    {
                        value: 'approved',
                        text: this.$t('status_approved')
                    },
                    {
                        value: 'declined',
                        text: this.$t('status_declined')
                    }
                ],

                haveMessageOptions: [
                    {
                        value: 1,
                        text: this.$t('there_is')
                    },
                    {
                        value: '0',
                        text: this.$t('absent')
                    }
                ],

                bulkMsgForm: {},
                importModalTitle: '',
                importModalMode: null,
                importFile: null,
                groupOptions: [
                    {
                        value: 1,
                        text: 1
                    },
                    {
                        value: 2,
                        text: 2
                    }
                ],
                paymentStatusOptions: [
                    {
                        value: 'E',
                        text: this.$t('yes')
                    },
                    {
                        value: 'H',
                        text: this.$t('no')
                    }
                ],

                importBulk: null
            }
        },
        created() {
            this.filterSet();
            this.actions = [
                {
                    text: this.$t('exam_info_download'),
                    permission: 'cartoonanimationapplication_examinformationexcelexport',
                    callback: () => {
                        this.examInformationExcelExport()
                    }
                },
                {
                    text: this.$t('exam_info_upload'),
                    permission: 'cartoonanimationapplication_examinformationexcelimport',
                    callback: () => {
                        this.$bvModal.show('importFormModal');
                        this.importModalTitle = this.$t('exam_info_upload')
                        this.importModalMode = 'exam_info_upload'
                        this.importFile = null
                    }
                },
                {
                    text: this.$t('exam_result_download'),
                    permission: 'cartoonanimationapplication_examresultexcelexport',
                    callback: () => {
                        this.examResultExcelExport()
                    }
                },
                {
                    text: this.$t('exam_result_upload'),
                    permission: 'cartoonanimationapplication_examresultexcelimport',
                    callback: () => {
                        this.$bvModal.show('importFormModal')
                        this.importModalTitle = this.$t('exam_result_upload')
                        this.importModalMode = 'exam_result_upload'
                        this.importFile = null
                    }
                },
                {
                    text: this.$t('exam_result_calc'),
                    permission: 'cartoonanimationapplication_calculateexampoints',
                    callback: () => {
                        this.calculateExamPoints()
                    }
                }
            ]
        },

        computed: {
            excelImportPermCheck(){
                return this.checkPermission('cartoonanimationapplication_applicationexcelimport')
            }
        },

        methods: {
            formClear(){
              this.formProcess=null
            },
            async filterSet() {
                this.datatable.queryParams.filter = {
                }
                this.nationalId = ''
                await this.getSelectedSemester()
            },
            async filterClear() {
                await this.filterSet()
                this.getRows();
            },
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            changeColumn(key) {
                this.datatable.columns[key].hidden = this.datatable.columns[key].hidden == true ? false : true;
            },
            onSortChange(params) {
                const sortType = params[0].type == 'desc' ? '-' : '';
                this.datatable.queryParams.sort = sortType + params[0].field
                this.getRows();
            },

            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                if(this.nationalId){
                    this.datatable.queryParams.filter.national_id= this.nationalId.split('\n').filter(id =>id !=="");
                }

                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                return CartoonAnimationService.getAll(config).then(response => {
                    this.datatable.rows = response.data.data
                    this.datatable.total = response.data.pagination.total
                }).catch(e => {
                    this.showErrors(e)
                }).finally(() => {
                    this.datatable.isLoading = false;
                });
            },

            openUpdateModal(data, updateMode, goTab){
                this.updateMode = updateMode
                this.formProcess='updateModal'
                this.updateTitle = data.name+' '+data.surname
                this.updateData = data
                this.goTabIndex = goTab
                this.$refs.updateModal.$refs.commonModal.show()
            },

            afterUpdate(){
                this.$refs.updateModal.$refs.commonModal.hide()
                this.getRows()
            },

            afterUpdateMsg(){
                this.getRows()
            },

            bulkMessage(){
                this.$refs.bulkMessageModal.$refs.commonModal.show()
            },

            async bulkMessageSend(){
                const isValid = await this.$refs.bulkMessageFormValidate.validate();
                if (isValid) {
                    let formData = {
                        filter: this.datatable.queryParams.filter,
                        ...this.bulkMsgForm
                    }
                    CartoonAnimationService.bulkMessage(formData).then(response => {
                        this.$toast.success(this.$t('api.'+response.data.message))
                        this.$refs.bulkMessageModal.$refs.commonModal.hide()
                        this.bulkMsgForm = {}
                    }).catch(e => {
                        this.showErrors(e)
                    })
                }
            },

            examInformationExcelExport(){
                CartoonAnimationService.examInformationExcelExport().then(response => {
                    this._downloadFile(response,this.$t('exam_info_download')+'.xlsx')
                }).catch(e => {
                    this.showErrors(e, null)
                })
            },

            async uploadFile(){
                const isValid = await this.$refs.importFormValidate.validate();
                if (isValid) {
                    if(this.importModalMode == 'exam_info_upload'){
                        let formData = new FormData()
                        formData.append('file', this.importFile);
                        CartoonAnimationService.importExamInformationExcelImport(formData).then(() => {
                            this.$toast.success(this.$t('proccess_success'))
                            this.$bvModal.hide('importFormModal')
                            this.importModalMode = null
                        }).catch(e => {
                            this.showErrors(e, this.$refs.importFormValidate)
                        })
                    } else if(this.importModalMode == 'exam_result_upload'){
                        let formData = new FormData()
                        formData.append('file', this.importFile);
                        CartoonAnimationService.importExamResultExcelImport(formData).then(() => {
                            this.$toast.success(this.$t('proccess_success'))
                            this.$bvModal.hide('importFormModal')
                            this.importModalMode = null
                        }).catch(e => {
                            this.showErrors(e, this.$refs.importFormValidate)
                        })
                    }
                }
            },

            examResultExcelExport(){
                CartoonAnimationService.examResultExcelExport().then(response => {
                    this._downloadFile(response,this.$t('exam_result_download')+'.xlsx')
                }).catch(e => {
                    this.showErrors(e, null)
                })
            },

            calculateExamPoints(){
                CartoonAnimationService.calculateExamPoints().then(response => {
                    this.$toast.success(this.$t('proccess_success'))
                }).catch(e => {
                    this.showErrors(e, null)
                })
            },

            excelExport(){
                if(this.datatable.queryParams.filter.national_id){
                    let nationalIds = this.datatable.queryParams.filter.national_id
                    if(typeof this.datatable.queryParams.filter.national_id == 'object'){
                        this.datatable.queryParams.filter.national_id = nationalIds.toString().split(`,`)
                    } else {
                        this.datatable.queryParams.filter.national_id = nationalIds.split(`\n`)
                    }
                }

                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                }

                CartoonAnimationService.applicationExcelExport(config).then(response => {
                    this._downloadFile(response, this.$t('results')+'.xlsx')
                }).catch(e => {
                    this.showErrors(e, null)
                })
            },

            deleteApplication(data){
                this.$swal.fire({
                        text: this.$t('are_you_sure_to_delete'),
                        showCancelButton: true,
                        confirmButtonText: this.$t('yes'),
                        cancelButtonText: this.$t('no'),
                        icon: 'question'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            CartoonAnimationService.deleteApplication(data.id).then(response => {
                                this.$toast.success(this.$t('api.'+response.data.message))
                                this.getRows()
                            }).catch(e => {
                                this.showErrors(e, null)
                            })
                        }
                    })
            },

            downloadDocuments(){
                if(this.datatable.queryParams.filter.national_id){
                    let nationalIds = this.datatable.queryParams.filter.national_id
                    if(typeof this.datatable.queryParams.filter.national_id == 'object'){
                        this.datatable.queryParams.filter.national_id = nationalIds.toString().split(`,`)
                    } else {
                        this.datatable.queryParams.filter.national_id = nationalIds.split(`\n`)
                    }
                }

                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                }

                CartoonAnimationService.downloadDocumentsZip(config).then(response => {
                    this._downloadFile(response, this.$t('results')+'.zip')
                }).catch(e => {
                    this.showErrors(e, null)
                })
            },

            excelImport(){
                this.$refs.excelImportModal.$refs.commonModal.show()
            },

            async importBulkExcel(){
                const isValid = await this.$refs.excelImportFormValidate.validate();
                if (isValid) {
                    let formData = new FormData()
                    formData.append('file', this.importBulk);
                    CartoonAnimationService.importBulkExcel(formData).then(response => {
                        window.open('/job/logs/detail/' + response.data.data.log_id, '_blank')
                        this.$toast.success(this.$t('proccess_success'))
                        this.$refs.excelImportModal.$refs.commonModal.hide()
                    }).catch(e => {
                        this.showErrors(e, this.$refs.importFormValidate)
                    })
                }
            },

            getSelectedSemester() {
                ConstantService.getValuePrivate('cartoon_animation_application.semester_id').then(response => {
                    this.$set(this.datatable.queryParams.filter, 'semester_id', response.data.data)
                }).catch(e => {
                    this.showErrors(e, null)
                })
            },

        }
    }
</script>

